import { render, staticRenderFns } from "./MobileNavbar.vue?vue&type=template&id=dc81854c"
import script from "./MobileNavbar.vue?vue&type=script&lang=js"
export * from "./MobileNavbar.vue?vue&type=script&lang=js"
import style0 from "./MobileNavbar.vue?vue&type=style&index=0&id=dc81854c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports